<template>
  <div id="article-grid">
    <div v-if="(clickedTags.length < 1) && (search === '')" class="latest-posts">
        <a v-for="(post, index) in refinedArrayComp" v-bind:key="index" name="latest-posts-item" @click="setArticle(post)">
          <img v-bind:src="post.acf.image.sizes.medium_large">
          <p class="playfair-normal" v-html="post.title.rendered"></p>
          <p v-html="post.excerpt.rendered"></p>
          <button class="tag">Läs mer</button>
          <!-- <CustomButton class="button"></CustomButton> -->
        </a>
    </div>
    <!-- <button @click="filterPosts">ok</button> -->
  </div>
</template>

<script>
import CustomButton from './CustomButton'

export default {
  name: 'ArticleGrid',
  data () {
    return {
      filteredPosts: [],
      search: '',
      searchResult: [],
      refinedArray: []
    }
  },
  props: [],
  beforeMount () {
    this.$store.dispatch('getPosts')
    this.$store.dispatch('getTags')
  },
  methods: {
    setArticle (article) {
      this.$store.dispatch('getArticle', article)
      this.$router.push('/article/' + article.slug)
      //  this.filterPosts(article)
      return false
    },
    filterPosts (post) {
      var articleTags = this.selectedArticle.tags
      var filteredArticles = []
      this.article.map(function (article) {
        article.tags.map(function (tag) {
          articleTags.map(function (articleTag, i, arr) {
            if (articleTag === tag) {
              filteredArticles.push(article)
            }
          })
        })
      })
      this.filteredPosts = filteredArticles.filter((v, i) => filteredArticles.indexOf(v) === i)
      this.oneOut(post)
    },
    oneOut (article) {
      var articlesMinusOne = article.filter((item) => item.id !== this.currentArticle.id)
      let sliced = articlesMinusOne.slice(0, 4)
      //  console.log('sliced: ', sliced, articlesMinusOne)
      return sliced
    }
  },
  mounted () {
  },
  computed: {
    article () {
      return this.$store.state.posts
    },
    pages () {
      return this.$store.state.pages
    },
    posts () {
      return this.$store.state.posts
    },
    tags () {
      return this.$store.state.tags
    },
    currentTags () {
      return this.$store.state.currentTags
    },
    currentArticle () {
      return this.$store.state.currentArticle
    },
    refinedArrayComp () {
      var articleTags = this.$store.state.currentArticle.tags
      //  console.log('articleTag = ', articleTags)
      var filteredArticles = []
      let posts = this.posts.slice()
      posts.map((post) => {
        post.tags.map((tag) => {
          articleTags.map((articleTag, i, arr) => {
            //  console.log('comparing ' + articleTag + ' === ' + tag)
            if (articleTag === tag) {
              filteredArticles.push(post)
            }
          })
        })
      })
      //  let filtered = filteredArticles.filter((v, i) => filteredArticles.indexOf(v) === i)
      //  console.log(filteredArticles)
      return this.oneOut(filteredArticles)
    },
    clickedTags () {
      return this.$store.state.currentTags
    },
    theTags () {
      return this.$store.state.tags
    }
  },
  components: { CustomButton }
}
</script>

<style lang="scss">
body {
  overflow-x: hidden;
}
button {
  cursor: pointer;
}
#article-grid .latest-posts {
  .playfair-normal {
    margin: 0 auto;
    width: 95%;
  }
  a[name=latest-posts-item] .text-container p {
    font-size: 16px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    width: 100%;
  }
}
@media #{$phones} {
}
</style>
<style lang="scss" scoped>
#article-grid {
  display: block;
  margin-left: -2.5%;
  margin-right: -2.5%;
//   height: 100%;
  .kort {
    color: black;
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 30px;
    button {
      background: $lightGrey;
      border: none;
      width: 23%;
      height: 40px;
      box-sizing: border-box;
      margin: 10px 2% 0 0;
      // font-size: 16px;
      // font-family: 'PlayfairDisplay-Bold';
    }
    .active {
      background: $purple;
    }
  }
  .latest-posts {
    width: 100%;
    height: auto;
    min-height: 714px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: left;
    margin-top: 20px;
    a[name=latest-posts-item] {
      width: 45%;
      display: block;
      box-sizing: border-box;
      margin: 0% 2.5% 5% 2.5%;
      border: 2px solid $lightGrey;
      height: 365px;
      position: relative;
      box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.05);
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover {
        box-shadow: 0px 0px 26px 0px rgba(0,0,0,0.19);
      }
      & > p {
        padding: 2px 10px;
        box-sizing: border-box;
      }
      color: inherit;
      text-decoration: inherit;
      padding-bottom: 50px;
    }
    .playfair-normal {
      margin-bottom: 8px;
      font-size: 20px;
      margin: 0;
    }
    img {
      width:100%;
      height: 50%;
      object-fit: cover;
      margin-bottom: 8px;
    }
    button {
      width:100%;
      min-height:50px;
      // font-family: 'PlayfairDisplay-Black';
      // font-size: 17px;
      color: $purple;
      background-color: $lightGrey;
      border: none;
      position:absolute;
      bottom:0;
      right: 0;
      cursor: pointer; // sass
    }
  }
}
@media screen and (max-width: 1200px) {
  #article-grid .tags button {
    width: 31%;
  }
}
@media screen and (max-width: 1800px) {
  #article-grid .latest-posts div[name=latest-posts-item] {
    width: 48%;
  }
}
@media #{$ipads} {
  #article-grid .tags {
    width: 70%;
  }
  #article-grid .latest-posts {
    width: 100%;
  }
}
@media #{$small-pads} {
  #article-grid .latest-posts a[name=latest-posts-item] {
    width: 96%;
  }
  #article-grid .tags {
    width: 95%;
  }
  #article-grid .latest-posts {
    width:100%;
  }
  #article-grid .latest-posts a[name=latest-posts-item] img {
    height: 33%;
    min-height: 125px;
  }
}
@media #{$phones} {
  #article-grid .tags {
    width: 95%;
    margin-bottom: 20px;
    margin-left: 1%;
    justify-content: center;
  }
  #article-grid .tags button {
    width: 48%;
  }
  #article-grid .latest-posts a[name=latest-posts-item] {
    width: 95%;
    margin:0 auto;
    margin-top:10px;
    margin-bottom: 20px;
    max-height: 350px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleGrid.vue